
import { Scene } from './icons';
import { WeatherDataRecord } from './types';
import { hasValue } from './utils';

// Status bar tint for iOS Safari, matches the top of each sky gradient.
export const THEME_COLORS: Record<Scene, string> = {
    day: '#3b82e6',
    night: '#0b1030',
    rain: '#4f6075',
};

// Rain if it rained in the last hour, otherwise day/night from the sunlight (or the clock before the first reading).
export function getScene(data?: WeatherDataRecord): Scene {
    if (data && (data.rainIn ?? 0) > 0) {
        return 'rain';
    }

    if (data && hasValue(data.solarRadiation)) {
        return data.solarRadiation > 5 ? 'day' : 'night';
    }

    const hour = new Date().getHours();
    return hour >= 7 && hour < 19 ? 'day' : 'night';
}
